export const isiData = [
  {
    head: 'What is SPRAVATO® (esketamine) CIII nasal spray?',
    list:
      'SPRAVATO® is a prescription medicine, used along with an antidepressant taken by mouth to treat: ',
    padding: 'top',
    nogap: true,
    items: [
      [
        'Adults with treatment-resistant depression (TRD)',
        'Depressive symptoms in adults with major depressive disorder (MDD) with suicidal thoughts or actions'
      ]
    ]
  },
  {
    list:
      'SPRAVATO® is not for use as a medicine to prevent or relieve pain (anesthetic). It is not known if SPRAVATO® is safe or effective as an anesthetic medicine.'
  },
  {
    list:
      'It is not known if SPRAVATO® is safe and effective for use in preventing suicide or in reducing suicidal thoughts or actions. SPRAVATO® is not for use in place of hospitalization if your healthcare provider determines that hospitalization is needed, even if improvement is experienced after the first dose of SPRAVATO®.'
  },
  {
    list: 'It is not known if SPRAVATO® is safe and effective in children.'
  },
  {
    head: 'SPRAVATO® can cause serious side effects, including:',
    padding: 'bottom',
    items: [
      [
        {
          copy: [
            'Sedation and dissociation. ',
            'SPRAVATO® may cause sleepiness (sedation), fainting, dizziness, spinning sensation, anxiety, or feeling disconnected from yourself, your thoughts, feelings, space and time (dissociation).'
          ],
          weight: ['bold', 'reg'],

          subList: [
            [
              'Tell your healthcare provider right away if you feel like you cannot stay awake or if you feel like you are going to pass out.',
              'Your healthcare provider must monitor you for serious side effects for at least 2  hours after taking SPRAVATO®. Your healthcare provider will decide when you are ready to leave the healthcare setting.'
            ]
          ]
        },
        {
          copy: [
            'Respiratory depression ',
            'was observed with the use of SPRAVATO®; additionally, there were rare reports of respiratory arrest.'
          ],
          weight: ['bold', 'reg'],

          subList: [
            [
              'Your healthcare provider must monitor you for serious side effects for at least 2 hours (including pulse oximetry) after taking SPRAVATO®. Your healthcare provider will decide when you are ready to leave the healthcare setting.'
            ]
          ]
        },
        {
          copy: [
            'Abuse and misuse. ',
            'There is a risk for abuse and physical and psychological dependence with SPRAVATO® treatment. Your healthcare provider should check you for signs of abuse and dependence before and during treatment with SPRAVATO®.'
          ],
          weight: ['bold', 'reg'],

          subList: [
            [
              'Tell your healthcare provider if you have ever abused or been dependent on alcohol, prescription medicines, or street drugs.',
              'Your healthcare provider can tell you more about the differences between physical and psychological dependence and drug addiction.'
            ]
          ]
        },
        {
          copy: [
            'SPRAVATO® Risk Evaluation and Mitigation Strategy (REMS).',
            ' Because of the risks for sedation, dissociation, respiratory depression, and abuse and misuse, SPRAVATO® is only available through a restricted program called the SPRAVATO® Risk Evaluation and Mitigation Strategy (REMS) Program. SPRAVATO® can only be administered at healthcare settings certified in the SPRAVATO® REMS Program. Patients treated in outpatient healthcare settings (e.g., medical offices and clinics) must be enrolled in the program.'
          ],
          weight: ['bold', 'reg']
        },
        {
          copy: [
            'Increased risk of suicidal thoughts and actions. ',
            'Antidepressant medicines may increase suicidal thoughts and actions in some people 24 years of age and younger, ',
            'especially within the first few months of treatment or when the dose is changed. SPRAVATO® is not for use in children.'
          ],
          weight: ['bold', 'reg', 'bold'],

          subList: [
            [
              'Depression and other serious mental illnesses are the most important causes of suicidal thoughts and actions. Some people may have a higher risk of having suicidal thoughts or actions. These include people who have (or have a family history of) depression or a history of suicidal thoughts or actions.'
            ]
          ]
        },
        {
          copy: [
            'How can I watch for and try to prevent suicidal thoughts and actions in myself or a family member?'
          ],
          weight: ['bold'],

          subList: [
            [
              'Pay close attention to any changes, especially sudden changes, in mood, behavior, thoughts, or feelings, or if you develop suicidal thoughts or actions.',
              'Tell your healthcare provider right away if you have any new or sudden changes in mood, behavior, thoughts, or feelings.',
              'Keep all follow-up visits with your healthcare provider as scheduled. Call your healthcare provider between visits as needed, especially if you have concerns about symptoms.'
            ]
          ]
        },
        {
          copy: [
            'Tell your healthcare provider right away if you or your family member have any of the following symptoms, especially if they are new, worse, or worry you:'
          ],
          weight: ['bold'],

          subList: [
            ['suicide attempts', 'thoughts about suicide or dying'],
            ['worsening depression', 'other unusual changes in behavior or mood']
          ]
        }
      ]
    ]
  },
  {
    head: 'Do not take SPRAVATO® if you:',
    items: [
      [
        'have blood vessel (aneurysmal vascular) disease (including in the brain, chest, abdominal aorta, arms and legs)',
        'have an abnormal connection between your veins and arteries (arteriovenous malformation)',
        'have a history of bleeding in the brain',
        'are allergic to esketamine, ketamine, or any of the other ingredients in SPRAVATO®.'
      ]
    ]
  },
  {
    list:
      'If you are not sure if you have any of the above conditions, talk to your healthcare provider before taking SPRAVATO®.'
  },
  {
    head:
      'Before you take SPRAVATO®, tell your healthcare provider about all of your medical conditions, including if you: ',
    items: [
      [
        {
          copy: ['have heart or brain problems, including:'],
          weight: ['reg'],
          subList: [
            [
              'high blood pressure (hypertension)',
              'slow or fast heartbeats that cause shortness of breath, chest pain, lightheadedness, or fainting',
              'history of heart attack',
              'history of stroke',
              'heart valve disease or heart failure',
              'history of brain injury or any condition where there is increased pressure in the brain'
            ]
          ]
        },
        'have liver problems',
        'have ever had a condition called “psychosis” (see, feel, or hear things that are not there, or believe in things that are not true).',
        {
          copy: [
            'are pregnant or plan to become pregnant. SPRAVATO® may harm your baby. You should not take SPRAVATO® if you are pregnant.'
          ],
          weight: ['reg'],
          subList: [
            [
              'Tell your healthcare provider right away if you become pregnant during treatment with SPRAVATO®.',
              'If you are able to become pregnant, talk to your healthcare provider about methods to prevent pregnancy during treatment with SPRAVATO®.',
              {
                copy: [
                  'There is a pregnancy registry for women who are exposed to SPRAVATO® during pregnancy. The purpose of the registry is to collect information about the health of women exposed to SPRAVATO® and their baby. If you become pregnant during treatment with SPRAVATO®, talk to your healthcare provider about registering with the National Pregnancy Registry for Antidepressants at 1-844-405-6185 or online at'
                ],
                weight: ['reg'],
                hyperlink: {
                  origin: 'isi',
                  href:
                    'https://womensmentalhealth.org/clinical-and-research-programs/pregnancyregistry/antidepressants/',
                  a:
                    'https://womensmentalhealth.org/clinical-and-research-programs/pregnancyregistry/antidepressants/'
                }
              }
            ]
          ]
        },
        'are breastfeeding or plan to breastfeed. You should not breastfeed during treatment with SPRAVATO®.'
      ]
    ]
  },
  {
    mixed: {
      copy: [
        'Tell your healthcare provider about all the medicines that you take,',
        ' including prescription and over-the-counter medicines, vitamins and herbal supplements. Taking SPRAVATO® with certain medicine may cause side effects.'
      ],
      weight: ['bold', 'reg']
    }
  },
  {
    mixed: {
      copy: [
        'Especially tell your healthcare provider if you take',
        ' central nervous system (CNS) depressants, psychostimulants, or monoamine oxidase inhibitors (MAOIs) medicine. Keep a list of them to show to your healthcare provider and pharmacist when you get a new medicine.'
      ],
      weight: ['bold', 'reg']
    }
  },
  {
    head: 'How will I take SPRAVATO®?',
    items: [
      [
        'You will take SPRAVATO® nasal spray yourself, under the supervision of a healthcare provider in a healthcare setting. Your healthcare provider will show you how to use the SPRAVATO® nasal spray device.',
        'Your healthcare provider will tell you how much SPRAVATO® you will take and when you will take it.',
        'Follow your SPRAVATO® treatment schedule exactly as your healthcare provider tells you to.',
        'During and after each use of the SPRAVATO® nasal spray device, you will be checked by a healthcare provider who will decide when you are ready to leave the healthcare setting.',
        'You will need to plan for a caregiver or family member to drive you home after taking SPRAVATO®.',
        'If you miss a SPRAVATO® treatment, your healthcare provider may change your dose and treatment schedule.',
        'Some people taking SPRAVATO® get nausea and vomiting. You should not eat for at least 2 hours before taking SPRAVATO® and not drink liquids at least 30 minutes before taking SPRAVATO®.',
        'If you take a nasal corticosteroid or nasal decongestant medicine take these medicines at least 1 hour before taking SPRAVATO®.'
      ]
    ]
  },
  {
    nogap: true,
    head: 'What should I avoid while taking SPRAVATO®?',
    mixed: {
      copy: [
        'Do not',
        ' drive, operate machinery, or do anything where you need to be completely alert after taking SPRAVATO®.',
        ' Do not',
        ' take part in these activities until the next day following a restful sleep. See',
        ' “What is the most important information I should know about SPRAVATO®?”'
      ],
      weight: ['bold', 'reg', 'bold', 'reg', 'bold']
    }
  },
  {
    head: 'What are the possible side effects of SPRAVATO®?',
    mixed: {
      copy: ['SPRAVATO® may cause serious side effects including:'],
      weight: ['bold']
    }
  },
  {
    mixed: {
      copy: ['See', ' “What is the most important information I should know about SPRAVATO®?”'],
      weight: ['reg', 'bold']
    }
  },
  {
    mixed: {
      copy: [
        'Increased blood pressure.',
        ' SPRAVATO® can cause a temporary increase in your blood pressure that may last for about 4 hours after taking a dose. Your healthcare provider will check your blood pressure before taking SPRAVATO® and for at least 2 hours after you take SPRAVATO®. Tell your healthcare provider right away if you get chest pain, shortness of breath, sudden severe headache, change in vision, or seizures after taking SPRAVATO®.'
      ],
      weight: ['med', 'reg']
    }
  },
  {
    mixed: {
      copy: [
        'Problems with thinking clearly.',
        ' Tell your healthcare provider if you have problems thinking or remembering.'
      ],
      weight: ['bold', 'reg']
    }
  },
  {
    mixed: {
      copy: [
        'Bladder problems.',
        ' Tell your healthcare provider if you develop trouble urinating, such as a frequent or urgent need to urinate, pain when urinating, or urinating frequently at night.'
      ],
      weight: ['bold', 'reg']
    }
  },
  {
    head:
      'The most common side effects of SPRAVATO® when used along with an antidepressant taken by mouth include:',
    items: [
      [
        'feeling disconnected from yourself, your thoughts, feelings, and things around you',
        'dizziness',
        'nausea',
        'feeling sleepy',
        'spinning sensation'
      ],
      [
        'decreased feeling of sensitivity (numbness)',
        'feeling anxious',
        'lack of energy',
        'increased blood pressure',
        'vomiting',
        'feeling drunk',
        'feeling very happy or excited'
      ]
    ]
  },
  {
    head:
      'If these common side effects occur, they usually happen right after taking SPRAVATO® and go away the same day.',
    list: 'These are not all the possible side effects of SPRAVATO®.'
  },
  {
    list:
      'Call your doctor for medical advice about side effects. You may report side effects to FDA at 1-800-FDA-1088.'
  }
];
